import { render, staticRenderFns } from "./Smart.vue?vue&type=template&id=00489850&scoped=true"
import script from "./Smart.vue?vue&type=script&lang=js"
export * from "./Smart.vue?vue&type=script&lang=js"
import style0 from "./Smart.vue?vue&type=style&index=0&id=00489850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00489850",
  null
  
)

export default component.exports